module.exports = __webpack_public_path__ + "img/interview_rmcf.86630733.svg";